export default ({ showEkPrice, showLager, showLieferanten, showWarnschwelle, showSollMenge }) => {
  const columns = [
    {
      name: 'Produkt',
      key: 'products.name',
      sortable: true,
      width: '300px'
    },
    {
      name: 'Kategorie',
      key: 'product_categories.name',
      sortable: true,
      width: '200px'
    },
    {
      name: 'Einheit',
      key: 'units.name',
      sortable: true
    }
  ]

  if (showEkPrice) {
    columns.push({
      name: 'EK Netto',
      key: 'einkaufspreis',
      sortable: true
    })
  }

  columns.push(
    {
      name: 'VK Brutto',
      key: 'products.price',
      sortable: true
    },
    {
      name: 'Auf Lager',
      key: 'quantity_sum',
      sortable: true
    },
    {
      name: 'Inventur',
      key: 'inventur_quantity',
      sortable: true
    },
    {
      name: 'Bestellt',
      sortable: false
    },
  )

  if (showWarnschwelle) {
    columns.push({
      name: 'Warnschwelle',
      key: 'warnschwelle_config',
      sortable: true
    })
  }

  if (showSollMenge) {
    columns.push({
      name: 'Lager Sollmenge',
      key: 'soll_menge_config',
      sortable: true
    })
  }

  columns.push({
    name: 'Exp',
    key: 'next_expiry_date',
    sortable: true,
    tooltip: 'Nächster Ablaufdatumstermin'
  })

  if (showLager) {
    columns.push({
      name: 'Lager',
      sortable: false,
      width: '68px'
    })
  }

  if (showLieferanten) {
    columns.push({
      name: 'Lieferanten',
      sortable: false,
      width: '68px'
    })
  }

  return columns
}
